export const API_ENDPOINTS = {
    login: '/user/login',
    refreshToken: '/refreshToken',
    concerts: {
        list: '/concert',
        create: '/concert',
        delete: id => `/concert/${id}`,
        edit: id => `/concert/${id}`,
    },
    generalSettings: {
        get: '/generalSettings',
        edit: '/generalSettings',
    },
    user: {
        resetPassword: '/resetPassword',
        setNewPassword: '/setNewPassword',
        list: '/user',
        create: '/user',
        update: id => `/user/${id}`,
        delete: id => `/user/${id}`,
    },
    lyricsCategories: {
        list: '/lyricsCategory',
        create: '/lyricsCategory',
        delete: id => `/lyricsCategory/${id}`,
        update: id => `/lyricsCategory/${id}`,
    },
    lyrics: {
        list: '/lyrics',
        create: '/lyrics',
        delete: id => `/lyrics/${id}`,
        update: id => `/lyrics/${id}`,
    },
    discographyAlbums: {
        list: '/discographyAlbum',
        create: '/discographyAlbum',
        delete: id => `/discographyAlbum/${id}`,
        update: id => `/discographyAlbum/${id}`,
    },
    discographyItems: {
        list: '/discographyItem',
        create: '/discographyItem',
        delete: id => `/discographyItem/${id}`,
        update: id => `/discographyItem/${id}`,
    },
    blog: {
        list: '/blog',
        create: '/blog',
        delete: id => `/blog/${id}`,
        update: id => `/blog/${id}`,
        uploadImage: `/blog/uploadImage`,
    }
};